module.exports = __webpack_public_path__ + "img/amx-17.aad0930d.jpg";